import { Map, fromJS } from 'immutable';

export function request(state, { target }) {
    return state
        .set('state', 'IN_PROGRESS')
        .setIn(['items', target], fromJS({}));
}

export function error(state, { target, errors }) {
    return state
        .set('state', 'ERROR')
        .setIn(['items', target, 'errors'], fromJS(errors));
}

export function finish(state, {target, prices}) {
    return state
        .set('state', 'FINISHED')
        .setIn(['items', target, 'prices'], fromJS(prices));
}
